document.addEventListener("DOMContentLoaded", function () {
  const PUBLIC_API_KEY = "SrESjx";

  const bisWrapper = document.querySelector(
    ".product-form .bis-inline-wrapper",
  );
  if (!bisWrapper) return;

  const productForm = bisWrapper.closest(".product-form");

  const bisBtn = productForm.querySelector(".bis-submit-button");
  const emailInput = productForm.querySelector(".bis-email-input");
  const messageBox = productForm.querySelector(".bis-message");
  const texts = productForm.querySelector(".bis-texts");

  const TEXT_SUCCESS =
    texts?.dataset.success || "Te avisaremos cuando esté disponible";
  const TEXT_ERROR = texts?.dataset.error || "Error. Inténtalo de nuevo";
  const TEXT_INVALID = texts?.dataset.invalid || "Introduce un email válido";

  function getCurrentVariant() {
    const input = productForm.querySelector('input[name="id"]');
    return input ? input.value : null;
  }

  function resetMessage() {
    if (!messageBox) return;
    messageBox.style.display = "none";
    messageBox.innerText = "";
    messageBox.className = "bis-message";
  }

  function isVariantAvailable() {
    const variantInput = productForm.querySelector('input[name="id"]');
    if (!variantInput || !window.productVariants) return true;

    const variantId = variantInput.value;

    const variantData = window.productVariants.find(
      (v) => String(v.id) === String(variantId),
    );

    return variantData ? variantData.available : false;
  }

  function updateBIS() {
    const available = isVariantAvailable();

    if (!available) {
      bisWrapper.style.display = "flex";
    } else {
      bisWrapper.style.display = "none";
    }

    const variantId = getCurrentVariant();
    if (bisBtn && variantId) {
      bisBtn.setAttribute("data-variant-id", variantId);
    }

    resetMessage();
  }

  updateBIS();

  document.addEventListener("change", function (e) {
    if (e.target.name === "id" && productForm.contains(e.target)) {
      setTimeout(updateBIS, 50);
    }
  });

  document.addEventListener("click", function (e) {
    const btn = e.target.closest(".bis-submit-button");
    if (!btn || !productForm.contains(btn)) return;

    const email = emailInput.value.trim();
    const variantId = btn.getAttribute("data-variant-id");

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(email)) {
      messageBox.style.display = "block";
      messageBox.className = "bis-message error";
      messageBox.innerText = TEXT_INVALID;
      return;
    }

    fetch(
      `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${PUBLIC_API_KEY}`,
      {
        method: "POST",
        headers: {
          accept: "application/vnd.api+json",
          "content-type": "application/vnd.api+json",
          revision: "2026-01-15",
        },
        body: JSON.stringify({
          data: {
            type: "back-in-stock-subscription",
            attributes: {
              channels: ["EMAIL"],
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: email,
                  },
                },
              },
            },
            relationships: {
              variant: {
                data: {
                  type: "catalog-variant",
                  id: `$shopify:::$default:::${variantId}`,
                },
              },
            },
          },
        }),
      },
    )
      .then((res) => {
        if (!res.ok) throw new Error(res.status);

        messageBox.style.display = "block";
        messageBox.className = "bis-message success";
        messageBox.innerText = TEXT_SUCCESS;
        emailInput.value = "";
      })
      .catch((err) => {
        console.error("Klaviyo error:", err);
        messageBox.style.display = "block";
        messageBox.className = "bis-message error";
        messageBox.innerText = TEXT_ERROR;
      });
  });
});
